import React, { useContext } from "react";
import { monthnames } from "../../../enums";
import { LanguageContext } from "../../../Context";

export default function MonthChoice(props) {
  let { month, setMonth, year, setYear, future } = props;
  let { language } = useContext(LanguageContext);
  
  let disabled =
    month === new Date().getMonth() && year === new Date().getFullYear();
  if (future) disabled = false;

  const back = () => {
    if (month > 0) {
      setMonth(month - 1);
    } else {
      setMonth(11);
      setYear(year - 1);
    }
  };

  const forward = () => {
    if (month < 11) {
      setMonth(month + 1);
    } else {
      setMonth(0);
      setYear(year + 1);
    }
  };

  return (
    <div className="flex items-center gap-1">
      <button 
        onClick={back}
        className="w-10 h-10 flex items-center justify-center rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-600 transition-all active:scale-90 cursor-pointer"
        aria-label="Previous Month"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
      </button>

      <div className="w-40 text-center">
        <div className="text-sm font-[800] text-slate-700 tracking-tight">
          {monthnames[month < 12 ? month + 1 : 1][language]}
        </div>
        <div className="text-[0.65rem] font-bold text-slate-400 tabular-nums">
          {year}
        </div>
      </div>

      <button 
        onClick={forward}
        disabled={disabled}
        className={`w-10 h-10 flex items-center justify-center rounded-xl transition-all active:scale-90 cursor-pointer ${
          disabled 
            ? "bg-slate-50 text-slate-200 cursor-not-allowed" 
            : "bg-slate-100 hover:bg-slate-200 text-slate-600"
        }`}
        aria-label="Next Month"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
      </button>
    </div>
  );
}
